const ErrorText = ({ text }) => {
  return <div className="text-red-500 text-[12px] font-light py-1">{text}</div>;
};

export default ErrorText;
